'use es6';

// import Raven from 'Raven';
const KEYS_TO_OMIT = ['xhr'];
const MAX_STRING_LENGTH = 2000;
const getTruncatedString = value => {
  const suffix = value.length > MAX_STRING_LENGTH ? '...' : '';
  return `${value.slice(0, MAX_STRING_LENGTH)}${suffix}`;
};
const cleanProperty = value => {
  switch (typeof value) {
    case 'string':
      {
        return getTruncatedString(value);
      }
    case 'function':
      {
        return 'function() { /* Function removed */ }';
      }
    case 'object':
      {
        // temporary fix to see which objects might be causing bloat
        return getTruncatedString(JSON.stringify(value));
      }
    default:
      return value;
  }
};
export const getFilteredPayloadData = errorPayload => {
  const filteredKeys = Object.keys(errorPayload).filter(key => !KEYS_TO_OMIT.includes(key));
  return filteredKeys.reduce((acc, key) => {
    const property = cleanProperty(errorPayload[key]);
    return Object.assign({}, acc, {
      [key]: property
    });
  }, {});
};
export default function () {
  return next => action => {
    // const { type } = action;

    // if (type.indexOf('_FAILED') > -1) {
    //   if (
    //     !(action && action.payload && action.payload.status === 0) ||
    //     !(action && action.payload && action.payload.status === 401)
    //   ) {
    //     const filteredPayload = getFilteredPayloadData(action.payload);
    //     const filteredAction = {
    //       ...action,
    //       payload: filteredPayload,
    //     };
    //     Raven.captureMessage(type, {
    //       extra: {
    //         action: filteredAction,
    //       },
    //     });
    //   } else {
    //     const status = action && action.payload && action.payload.status;
    //     console.error(`Skipped sentry call for error with status ${status}`);
    //   }
    // }

    return next(action);
  };
}